import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { alarmsAPI, alertsAPI } from '../services/api';
import useWebSocket from './useWebSocket';

export const useMenuBadges = () => {
  const [badges, setBadges] = useState({
    alerts: 0,
    alarms: 0,
    notifications: 0
  });
  const { user } = useAuth();

  const fetchBadges = async () => {
    if (!user) return;
    
    try {
      const [alarmsRes, alertsRes] = await Promise.all([
        alarmsAPI.getAll().catch(() => ({ data: { data: [] } })),
        alertsAPI.getStats().catch(() => ({ data: { data: {} } }))
      ]);

      const activeAlarms = alarmsRes.data?.data?.filter(a => a.status !== 'ACKNOWLEDGED') || [];
      const alertsData = alertsRes.data?.data || {};

      setBadges({
        alarms: activeAlarms.length,
        alerts: alertsData.pending_alerts || 0,
        notifications: alertsData.total_alerts_today || 0
      });
    } catch (error) {
      console.error('Erro ao buscar badges:', error);
    }
  };

  useWebSocket(null, {
    onMessage: (data) => {
      if (data.type === 'NEW_ALARM' && data.tenantId === user?.tenant_id) {
        fetchBadges();
      }
    }
  });

  useEffect(() => {
    fetchBadges();
    const interval = setInterval(fetchBadges, 30000);
    return () => clearInterval(interval);
  }, [user]);

  return badges;
};